// extracted by mini-css-extract-plugin
export default {"container":"al-z","blurb":"bl-z","links":"cl-z"};